import Decimal from 'decimal.js-light';

export const renderDecimalValue = (value: any) => {
  return value == null
    ? '-'
    : value instanceof Decimal
    ? value.toFixed()
    : value;
};
